import { CommonRouteNames } from './commonRouteNames'
import { ModuleRouteNames } from './moduleRouteNames'


export const RouteNames = {
  ...CommonRouteNames,
  ...ModuleRouteNames,
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type RouteNames =
  | CommonRouteNames
  | ModuleRouteNames
